import { SxProps, Theme } from "@mui/material/styles";

export const customFilterHeaderStyles = {
  container: {
    display: "flex",
    marginLeft: 2,
  } as React.CSSProperties,

  filterIcon: {
    fontSize: "16px",
    color: "#1976d2",
    marginRight: 0.5,
  } as SxProps<Theme>,

  filterChip: {
    height: "18px",
    fontSize: "0.65rem",
    backgroundColor: "#1976d2",
    marginLeft: "-5px",
    marginTop: "-8px",
    color: "white",
    minWidth: "20px",
    "& .MuiChip-label": {
      paddingLeft: "4px",
      paddingRight: "4px",
    },
  } as SxProps<Theme>,
};
